export const LCAADMIN = 'LCAADMIN';
export const CUSTOMER_ADMIN = 'CUSTADMIN';
export const ORGANIZATION_ACCESS_ROLES = [LCAADMIN, CUSTOMER_ADMIN];
export const USER_ACCESS_ROLES = [LCAADMIN, CUSTOMER_ADMIN];
export const FEEDADMIN = 'FEEDADMIN';
export const USER = 'USER';
